<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="subVisible" width="922px"
		ref="dialog">
		<el-row>
			<div class="warn_msg">编辑文字内容的时候，不需要人工写编号，系统自动生成。</div>
		</el-row>
		<el-row>
			<div class="tiv">描述</div>
		</el-row>
		<el-row style="margin-top:10px;margin-bottom:10px">
			<el-input type="textarea" rows="10" v-model="dataForm.itemContent" placeholder="请填写"></el-input>
		</el-row>
		<el-row>
			<div class="tiv">
				照片上传
			</div>
		</el-row>
		<el-row style="margin-left:114px;margin-top:10px">
			<el-col :span="24">
				<el-upload ref="uploadSituation" class="upload-demo" action="action" style="margin-left: -115px;"
					:http-request="uploadSituation" multiple drag :show-file-list=false :auto-upload="true"
					accept="image/jpeg,image/png,image/jpg" :before-upload="beforeUploadSituation">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-col>
		</el-row>
		<el-row style="margin-top:10px">
			<el-col :span="24">
				<el-table v-if="dataForm.photoRecords != undefined && dataForm.photoRecords.length > 0" border
					:data="dataForm.photoRecords" style="width: 100%;">
					<el-table-column type="index" label="No." width="60" align="center">
					</el-table-column>
					<el-table-column label="图片" width="180" align="center">
						<template slot-scope="scope">
							<el-image style="height: 100px" :src="scope.row.compressedPathUri" fit='contain'></el-image>
						</template>
					</el-table-column>
					<el-table-column label="描述" width="500px" align="center">
						<template slot-scope="scope">
							<el-input type="textarea" rows="2"
								v-model="dataForm.photoRecords[scope.$index].photoContent" placeholder="请填写"></el-input>
						</template>
					</el-table-column>
					<el-table-column label=" " width="120" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click="delPhoto(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import { initDialogDrag } from '@/utils/dialogDrag.js'
export default {
	name: "add-or-update-meeting",
	data() {
		return {
			subVisible: true,
			dataForm: {
				recNo: '',
				dataKind: '',
				workLogRecNo: '',
				itemNo: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				itemContent: '',
				filePath: '',
				photoRecords: [],
				updUserName: '',
			},
			recNo: '',
			title: '',
			itemNo: ''
		};
	},
	methods: {
		init(workLogRecNo, recNo, sort, itemNo, subjectNo) {
			// 标题
			if (itemNo === '01') {
				if (!recNo) {
					this.title = '新增概述'
				} else {
					this.title = '修改概述'
				}
			} else if (itemNo === '0203') {
				if (!recNo) {
					this.title = '新增报验及巡检情况'
				} else {
					this.title = '修改报验及巡检情况'
				}
				// } else if (itemNo === '02') {
				// 	if (!recNo) {
				// 		this.title = '新增报验情况'
				// 	} else {
				// 		this.title = '修改报验情况'
				// 	}
				// } else if (itemNo === '03') {
				// 	if (!recNo) {
				// 		this.title = '新增巡检情况'
				// 	} else {
				// 		this.title = '修改巡检情况'
				// 	}
			} else if (itemNo === '04') {
				if (!recNo) {
					this.title = '新增会议情况'
				} else {
					this.title = '修改会议情况'
				}
			} else if (itemNo === '05') {
				if (!recNo) {
					this.title = '新增协调记录'
				} else {
					this.title = '修改协调记录'
				}
			} else if (itemNo === '06') {
				if (!recNo) {
					this.title = '新增其他'
				} else {
					this.title = '修改其他'
				}
			} else if (itemNo === '07') {
				if (!recNo) {
					this.title = '新增进度详情'
				} else {
					this.title = '修改进度详情'
				}
			} else if (itemNo === '08') {
				if (!recNo) {
					this.title = '新增文件审查情况'
				} else {
					this.title = '修改文件审查情况'
				}
			} else if (itemNo === '10') {
				if (!recNo) {
					this.title = '新增本日（班）签发文件清单'
				} else {
					this.title = '修改本日（班）签发文件清单'
				}
			} else if (itemNo === '20') {
				if (!recNo) {
					this.title = '新增本日（班）备忘'
				} else {
					this.title = '修改本日（班）备忘'
				}
			}
			this.itemNo = itemNo

			this.dataForm = {
				recNo: '',
				subjectNo: '',
				workLogRecNo: workLogRecNo,
				itemNo: this.itemNo,
				sourceId: '',
				sourceType: '',
				sort: sort,
				itemContent: '',
				photoRecords: [],
				updUserName: $common.getItem("userName"),
			}
			this.dataForm.recNo = recNo;
			this.dataForm.subjectNo = subjectNo;
			this.$nextTick(() => {
				this.subVisible = true;
				// 👇 启用拖拽（只需要这一行）
				initDialogDrag(this.$refs.dialog.$el);
			})
			if (recNo) {
				this.getWorklogDetail();
			}

		},
		beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
		getWorklogDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/worklogdetailinfo/getWorkLogDetail/" + this.dataForm.recNo,
				method: 'get',
				params: this.$http.adornParams({})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body
					this.dataForm.updUserName = $common.getItem("userName")
				}
			})

		},
		uploadSituation(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadSituation.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/89/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.dataForm.photoRecords.push({
						photoFilePath: res.body.fileSavePath,
						fileUri: res.body.fileUri,
						compressedPath: res.body.compressedPath,
						compressedPathUri: res.body.fileUri,
						photoContent: this.extractFileName(res.body.fileName),
						recNo: '',
						updUserName: $common.getItem("userName"),
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		delPhoto(index) {
			this.dataForm.photoRecords.splice(index, 1);
		},
		dataSubmit() {
			let _url = "/business/worklogdetailinfo/save";
			if (this.dataForm.recNo && this.dataForm.recNo != 0) {
				_url = "/business/worklogdetailinfo/update";
			}
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataForm)
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
	}
};
</script>

<style scoped="scoped">
.tiv {
	width: 135px !important;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
	padding: 10px !important;
	text-align: center;
	border: 1px solid #dadada;
}

.upload-demo /deep/ .el-upload-dragger {
	width: 468%;
	height: 100px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
	line-height: 8px;
}

.warn_msg {
	margin-bottom: 10px;
	color: red;
}
</style>
